import bannerImg from './banners/woman-helping-man-gym.jpg';


export default {
    id: 'onboarding',
    title: 'Onboarding de membros',
    description: 'Dê as boas-vindas e entenda as expectativas de quem acabou de entrar na sua comunidade.',
    indicatedFor: 'Comunidades online',
    stepsCount: 2,
    questionsSummary: ['Nome completo', 'Como conheceu', 'Objetivo na comunidade', 'Experiência prévia'],
    banner: `url(${bannerImg}) center / cover no-repeat`,

    formData: {
        title: 'Onboarding de membros',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Quem é você?',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Qual é o seu nome completo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: 'Como você conheceu a comunidade?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Instagram' },
                                { id: 'opt-2', label: 'Indicação de amigo' },
                                { id: 'opt-3', label: 'YouTube' },
                                { id: 'opt-4', label: 'Outro' },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: 'Suas expectativas',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: 'Qual é o seu principal objetivo aqui?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: 'Você já participou de outras comunidades online?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
